import dayjs from 'dayjs';
import { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Button from 'src/components/Button';
import { PRODUCT_REGION } from 'src/constants/product';
import { useModal } from 'src/ModalContext';
import { postImpUnsubscribe, postPaypalUnsubscribe } from 'src/services/checkout';
import { getDurationTranslation, isKorean } from 'src/services/util';
import { useUser } from 'src/UserContext';

/**
 * SUB_ACTIVATED
 */
export default function AutoPaymentActivatedCard({ obj }: { obj: CheckoutUserProduct }): JSX.Element {
  const { t } = useTranslation();
  const { userInfo } = useUser();
  const { showModal } = useModal();
  const getName = () => {
    return isKorean() ? obj.koName : obj.enName;
  };

  const onCancel = useCallback(() => {
    showModal({
      title: `${obj.category} ${getName()}`,
      message: t('product/auto-payment/confirm_cancel_1'),
      success: async () => {
        try {
          if (userInfo.country === PRODUCT_REGION.KR) {
            await postImpUnsubscribe(obj.customerId);
          } else {
            await postPaypalUnsubscribe(obj.customerId);
          }
          showModal({
            title: `${getName()}`,
            message: t('product/auto-payment/success_cancel_1'),
            success: () => {
              location.reload();
            },
          });
        } catch (e) {
          console.error(e);
          showModal({
            message: e.message,
            success: () => {
              // success
            },
          });
        }
      },
      fail: () => {
        // no action
      },
    });
  }, [obj, userInfo]);

  return (
    <div className="mt-3">
      <div className="border border-ice-blue bg-white rounded px-6 pt-6 pb-5 min-h-48">
        <div className="N_16_R text-black">{getName()}</div>
        <div className="N_12_R text-brown-grey mt-1">
          <Trans i18nKey={getDurationTranslation(obj.durationType)} values={{ period: obj.duration }}></Trans>
        </div>
        <div className="mt-4 flex">
          <div className="N_12_R text-brown-grey">{t('product/auto-payment/next_payment_date')}</div>
          <div className="N_12_R text-ice-blue w-3 text-center">|</div>
          <div className="N_12_M text-bluey-purple">{dayjs(obj.endDate).format('YYYY.MM.DD')}</div> {/* TODO +1일? */}
        </div>
        <div className="mt-6">
          <Button title={t('product/auto-payment/cancel_2')} /* 해지신청 */ theme="sub" onClick={onCancel} />
        </div>
      </div>
    </div>
  );
}
